import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';

const Alert = ({ scope }) => {
  const { id, content, dismissable, duration, show, title, type } = useSelector(
    (state) => state.notifier.alert[scope],
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (show && id === scope && duration !== 0) {
      setTimeout(() => {
        dispatch(setAlert({ id, show: false }));
      }, duration * 1000); // Seconds
    }
  }, [dispatch, duration, id, scope, show]);

  if (!show || id !== scope) {
    return null;
  }

  return (
    <div className={`alert ${type ? `alert-${type}` : null}`}>
      {dismissable && (
        <button
          className="close unstyled wb-icon wb-circular-icon wb-icon-remove"
          onClick={() => dispatch(setAlert({ id, show: false }))}
        ></button>
      )}
      <strong>{title}</strong>&nbsp;
      <span dangerouslySetInnerHTML={{ __html: content }}></span>
    </div>
  );
};

export default Alert;
